import request from '@/http/request'

export const uidSendFailurePage = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-email/api/report/uidSendFailure`, params)
}

export const uidSendFailureDownload = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-email/api/report/uidSendFailureDownload`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const uidSendFailureResend = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-ant-service/tag/uidFailureReport/resend`, params, {
    reSend: true
  })
}
